/** Brief 12, Kapitan - Platforma: the panel's frame and its redesigned sections. */
export const uzB12Platform = {
  "plat.shell.title": "Kapitan admin",
  "plat.shell.who": "{name} · Platforma admini",
  "plat.shell.exit": "Chiqish",
  "plat.shell.sections": "Platforma bo'limlari",
  "plat.nav.tenants": "Tenantlar",
  "plat.nav.create": "Tenant yaratish",
  "plat.nav.support": "Support rejimi",
  "plat.nav.providers": "Provayderlar holati",
  "plat.nav.channels": "Kanallar holati",
  "plat.nav.ai": "AI sarfi",
  "plat.nav.billing": "Billing va tariflar",
  "plat.nav.catalogues": "Kataloglar",
  "plat.nav.hotels": "Otel normalizatsiya",
  "plat.nav.leads": "Landing so'rovlari",
  "plat.nav.credits": "Kredit so'rovlari",
  "plat.nav.audit": "Audit jurnali",
  "plat.nav.airports": "Aeroportlar",
  "plat.nav.destinations": "Yo'nalishlar",
  "plat.nav.settings": "Tizim sozlamalari",
  "plat.nav.system": "Tizim holati",
  "plat.retry": "Qayta urinish",
  "plat.denied": "Bu bo'limga kirish huquqingiz yo'q.",
  "plat.loadError": "Ma'lumotni yuklab bo'lmadi.",
  "plat.prev": "Oldingi",
  "plat.next": "Keyingi",
  "plat.tenants.title": "Tenantlar",
  "plat.tenants.all": "Barcha tenantlar",
  "plat.tenants.sub": "{count} ta agentlik · qatorni bosing",
  "plat.tenants.empty": "Agentliklar yo'q.",
  "plat.status.active": "Faol",
  "plat.status.suspended_billing": "Billing to'xtatgan",
  "plat.status.suspended_admin": "Admin to'xtatgan",
  "plat.status.closed": "Yopilgan",
  "plat.col.tenant": "Tenant",
  "plat.col.slug": "Slug",
  "plat.col.status": "Holat",
  "plat.col.tariff": "Tarif",
  "plat.col.credit": "Kredit",
  "plat.col.activity": "Faollik",
  "plat.col.channels": "Kanallar",
  "plat.tenant.members": "{tariff} · {count} xodim",
  "plat.tenant.channels": "TG {telegram} · IG {instagram}",
  "plat.tenant.channelsWarn": "{channels} · {count} ogoh.",
  "plat.tenant.back": "← Ro'yxatga",
  "plat.tenant.cardSub": "Tenant kartochkasi",
  "plat.tenant.moveStatus": "Holatni o'zgartirish",
  "plat.tenant.assignTariff": "Tarifni belgilash",
  "plat.tenant.journal": "Agentlik jurnali",
  "plat.tenant.balance": "Balans",
  "plat.tenant.aiMonth": "AI sarfi · oy",
  "plat.tenant.aiMonthValue": "{count} kr",
  "plat.tenant.membersKpi": "A'zolar",
  "plat.tenant.noTariff": "Yo'q",
  "plat.card.members": "A'zolar",
  "plat.card.name": "Ism",
  "plat.card.role": "Rol",
  "plat.card.lastLogin": "Oxirgi kirish",
  "plat.card.channels": "Kanallar va provayderlar",
  "plat.card.title": "Nomi",
  "plat.card.kind": "Turi",
  "plat.card.provider": "Provayder",
  "plat.card.history": "Billing tarixi va audit",
  "plat.card.date": "Sana",
  "plat.card.event": "Hodisa",
  "plat.card.amount": "Summa",
  "plat.card.empty": "Hali yozuv yo'q.",
  "plat.card.profile": "Profil",
  "plat.card.created": "Yaratilgan",
  "plat.card.email": "Email",
  "plat.card.branch": "Filial",
  "plat.card.active": "Faol",
  "plat.card.inactive": "Faol emas",
  "plat.card.channelsOnly": "Kanallar",
  "plat.card.sync": "Oxirgi sinxronlash",
  "plat.card.attention": "E'tibor kerak",
  "plat.card.paused": "To'xtatilgan",
  "plat.card.running": "Ishlamoqda",
  "plat.card.providers": "Provayderlar",
  "plat.card.checked": "Oxirgi tekshiruv",
  "plat.card.errorRate": "Xato, % (24 soat)",
  "plat.card.aiSpend": "AI sarfi",
  "plat.card.aiSpendSub": "{from} — {to}. Tokenlar va ishga tushishlar; narx yo'q.",
  "plat.card.aiEmpty": "Bu davrda AI ishlamagan.",
  "plat.card.model": "Model",
  "plat.card.runs": "Ishga tushish",
  "plat.card.playground": "Sinov",
  "plat.card.promptTokens": "Kiruvchi token",
  "plat.card.completionTokens": "Chiquvchi token",
  "plat.role.owner": "Egasi",
  "plat.role.branch_manager": "Menejer",
  "plat.role.moliyachi": "Moliyachi",
  "plat.role.operator": "Operator",
  "plat.create.title": "Tenant yaratish",
  "plat.create.name": "Nomi",
  "plat.create.slug": "Slug (bo'sh qolsa nomdan olinadi)",
  "plat.create.timezone": "Vaqt zonasi",
  "plat.create.currency": "Valyuta",
  "plat.create.language": "Til",
  "plat.create.languageUz": "O'zbek",
  "plat.create.tariff": "Tarif",
  "plat.create.tariffLater": "Keyinroq",
  "plat.create.email": "Egasi emaili",
  "plat.create.ownerName": "Egasining ismi",
  "plat.create.branches": "Filiallar (har biri yangi qatorda)",
  "plat.create.submit": "Tenant yaratish va egasiga taklif yuborish",
  "plat.create.done": "Tenant yaratildi",
  "plat.create.error": "Tenantni yaratib bo'lmadi.",
  "plat.create.emailed": "Taklif {email} manziliga yuborildi.",
  "plat.create.another": "Yana tenant yaratish",
  "plat.create.open": "Kartochkani ochish",
  "plat.support.title": "Support rejimi",
  "plat.support.new": "Yangi support sessiya",
  "plat.support.tenant": "Tenant",
  "plat.support.choose": "Tanlang",
  "plat.support.duration": "Muddat",
  "plat.support.reason": "Sabab",
  "plat.support.reasonHint": "Masalan: tiket 482 · Telegram akkaunt ulanmayapti",
  "plat.support.write": "O'zgartirish ruxsati",
  "plat.support.start": "Boshlash",
  "plat.support.started": "Support rejimi boshlandi · {name}",
  "plat.support.startError": "Support rejimini boshlab bo'lmadi.",
  "plat.support.active": "Faol sessiyalar",
  "plat.support.activeEmpty": "Faol sessiya yo'q.",
  "plat.support.register": "Sessiyalar jurnali",
  "plat.support.registerEmpty": "Sessiyalar yo'q.",
  "plat.support.staff": "Xodim",
  "plat.support.left": "Qoldi",
  "plat.support.leftMinutes": "{count} daq",
  "plat.support.ended": "Yopilgan",
  "plat.support.expired": "Muddati tugagan",
  "plat.support.enter": "Agentlikka kirish",
  "plat.support.close": "Yopish",
  "plat.support.closed": "Support sessiyasi yopildi.",
  "plat.support.closeError": "Sessiyani yopib bo'lmadi.",
  "plat.providers.title": "Provayderlar holati",
  "plat.providers.block": "Provayder adapterlari",
  "plat.providers.sub": "Kanareyka · har 5 daqiqada sinov qidiruvi",
  "plat.providers.empty": "Provayder hisoblari yo'q.",
  "plat.providers.adapter": "Adapter",
  "plat.providers.version": "Versiya",
  "plat.providers.canary": "Kanareyka",
  "plat.providers.errors": "Xato %",
  "plat.providers.breaker": "Circuit breaker",
  "plat.providers.closed": "Yopiq",
  "plat.providers.halfOpen": "Sinov",
  "plat.providers.open": "Ochiq",
  "plat.providers.owner": "Mas'ul",
  "plat.channels.title": "Kanallar holati",
  "plat.channels.block": "Telegram sessiyalari va Instagram tokenlari",
  "plat.channels.tg": "TG sessiyalar",
  "plat.channels.paused": "To'xtatilgan",
  "plat.channels.ig": "IG tokenlar",
  "plat.channels.errors": "Xato",
  "plat.channels.empty": "Ulangan kanallar yo'q.",
  "plat.channels.channel": "Kanal",
  "plat.channels.kind": "Turi",
  "plat.channels.state": "Holat",
  "plat.channels.sync": "Oxirgi sinxron",
  "plat.channels.flood": "Flood kutmoqda",
  "plat.channels.ok": "Ulangan",
  "plat.channels.bad": "Qayta ulash kerak",
  "plat.channels.pausedRow": "To'xtatilgan",
  "plat.ai.title": "AI sarfi",
  "plat.ai.block": "AI sarfi · {month}",
  "plat.ai.credits": "Jami kredit",
  "plat.ai.tokens": "Token",
  "plat.ai.avg": "O'rtacha / tenant",
  "plat.ai.today": "Bugun",
  "plat.ai.month": "Oy",
  "plat.ai.model": "Model",
  "plat.ai.empty": "Bu oyda AI ishlamagan.",
  "plat.ai.noRatio": "Kredit narxi belgilanmagan: ustunlar tokenda ko'rsatilgan.",
  "plat.billing.title": "Billing va tariflar",
  "plat.billing.tariffs": "Tariflar",
  "plat.billing.addTariff": "+ Tarif qo'shish",
  "plat.billing.creditPrice": "Kredit narxini o'zgartirish",
  "plat.billing.topUp": "Balans to'ldirish",
  "plat.billing.adjust": "Tuzatish",
  "plat.billing.tariff": "Tarif",
  "plat.billing.price": "Narx / oy",
  "plat.billing.staff": "Xodimlar",
  "plat.billing.staffAny": "cheksiz",
  "plat.billing.aiCredits": "AI kredit / oy",
  "plat.billing.state": "Holat",
  "plat.billing.inactive": "Faol emas",
  "plat.billing.note": "1 kredit = {tokens} token. Paket kreditlari oy oxirida yonadi, sotib olinganlari 12 oy amal qiladi.",
  "plat.billing.noteUnset": "Kredit narxi hali belgilanmagan. Paket kreditlari oy oxirida yonadi, sotib olinganlari 12 oy amal qiladi.",
  "plat.billing.empty": "Tariflar yo'q.",
  "plat.billing.adjustments": "Tuzatishlar",
  "plat.billing.adjEmpty": "Tuzatishlar yo'q.",
  "plat.billing.date": "Sana",
  "plat.billing.amount": "Summa",
  "plat.billing.reason": "Sabab",
  "plat.credit.title": "Kredit narxi",
  "plat.credit.tokens": "1 kredit = N token",
  "plat.credit.saved": "1 kredit = {tokens} token",
  "plat.credit.error": "Kredit narxini saqlab bo'lmadi.",
  "plat.grant.title": "Kredit qo'shish",
  "plat.grant.credits": "Kredit",
  "plat.grant.note": "Izoh",
  "plat.grant.noteHint": "Masalan: bank o'tkazmasi №1182",
  "plat.grant.saved": "{name}: +{count} kredit",
  "plat.grant.error": "Kredit qo'shib bo'lmadi.",
  "plat.adjust.title": "Balansni tuzatish",
  "plat.adjust.amount": "Summa, UZS (kamaytirish uchun minus)",
  "plat.adjust.saved": "Tuzatish yozildi",
  "plat.adjust.error": "Tuzatishni yozib bo'lmadi.",
  "plat.dialog.cancel": "Bekor qilish",
  "plat.dialog.save": "Saqlash",
  "plat.catalogues.title": "Kataloglar",
  "plat.catalogues.block": "Global kataloglar",
  "plat.catalogues.name": "Katalog",
  "plat.catalogues.count": "Yozuvlar",
  "plat.catalogues.updated": "Oxirgi yangilanish",
  "plat.catalogues.destinations": "Yo'nalishlar va aliaslar",
  "plat.catalogues.airports": "Aeroportlar",
  "plat.catalogues.hotels": "Otellar (normalizatsiya qilingan)",
  "plat.catalogues.templates": "AI shablonlari",
  "plat.catalogues.providers": "Provayderlar ro'yxati",
  "plat.catalogues.inCode": "kodda",
  "plat.hotels.title": "Otel normalizatsiya",
  "plat.hotels.question": "Bu ikkisi bitta otelmi?",
  "plat.hotels.why": "Nom o'xshashligi {score}%",
  "plat.hotels.noSuggestion": "Mos taklif topilmadi: alohida otel sifatida saqlang.",
  "plat.hotels.yes": "Ha, bitta otel",
  "plat.hotels.no": "Yo'q, har xil",
  "plat.hotels.merged": "Birlashtirildi",
  "plat.hotels.split": "Har xil deb belgilandi",
  "plat.hotels.error": "Qarorni saqlab bo'lmadi.",
  "plat.hotels.empty": "Navbat bo'sh",
  "plat.hotels.catalogue": "Katalogdagi otel",
  "plat.leads.title": "Landing so'rovlari",
  "plat.leads.block": "Landing so'rovlari · kapitan-crm.uz formasi",
  "plat.leads.date": "Sana",
  "plat.leads.name": "Ism",
  "plat.leads.agency": "Agentlik",
  "plat.leads.phone": "Telefon",
  "plat.leads.city": "Shahar",
  "plat.leads.state": "Holat",
  "plat.leads.filter": "Holat bo'yicha",
  "plat.leads.all": "Hammasi",
  "plat.leads.empty": "Landing so'rovlari yo'q.",
  "plat.leads.move": "Holat",
  "plat.leads.convert": "Agentlikka aylantirish",
} as const;
